<app-auth [isAtLeastMedium]="isAtLeastMedium">
  <div layout-body>
    <form novalidate class="mb-5" name="Fuser" class="container-fluid">
            <div class="connect py-3">
                <div class="icon-box info"><i class="fa fa-undo"></i>
                </div>
                <div class="header-content mt-4">
                    <div class="title-connect">Créer votre compte?</div>
                </div>
            </div>   
            <div class="header connect">
                <div class="header-content mb-3">
                    <div class="subtitle">Vérifiez vos informations et créez votre mot de passe</div>
                </div>
            
                <div class="login-content">
                    <div class="fields">
                        <div class="forget">
                            <div class="py-1">
                                <label for="login">Identification de connexion</label>
                                <stInput name="login" type="text" innerId="login" 
                                    [(ngModel)]="login"
                                    class="custom-placeholder">
                                </stInput>
                            </div>
                            <div class="py-1">
                                <label for="firstname">Prénom</label>
                                <stInput name="firstname" type="text" innerId="firstname" 
                                    [(ngModel)]="firstname" placeholder="Entrez votre prénom"
                                    class="custom-placeholder">
                                </stInput>
                            </div>
                            <div class="py-1">
                                <label for="lastname">Nom</label>
                                <stInput name="lastname" type="text" innerId="lastname" 
                                    [(ngModel)]="lastname" placeholder="Entrez votre nom"
                                    class="custom-placeholder">
                                </stInput>
                            </div>
                            <div class="py-1">
                                <label for="email">Adresse email</label>
                                <stInput name="email" type="text" innerId="email" 
                                    [(ngModel)]="email" placeholder="Entrez votre mail" [isDisabled]="true"
                                    class="custom-placeholder isDisabled input-disabled">
                                </stInput>
                            </div>
                            <div class="py-1 change-password">
                                <label for="password">Mot de passe</label>
                                <stInput name="password" type="password" innerId="password" 
                                    [(ngModel)]="password" placeholder="Choisissez votre mot de passe" 
                                    class="custom-placeholder"
                                    (ngModelChange)="validatePassword()"
                                    [class.isInvalid]="!isPasswordValid">
                                </stInput>
                                <div class="hint" *ngIf="!isPasswordValid && password" [ngClass]="{ 'invalid-hint': !isPasswordValid && password }">
                                    Au moins 8 caractères, dont 1 chiffre, 1 majuscule et un caractère spécial ? ! / , ;
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-full-width w-100 btn-create">
                        <stButton btnLabel="Créer mon compte" 
                            btnClass="btn-color" 
                            (onClick)="onSubmit()">
                        </stButton>
                    </div>
                </div>      
                <div class="user-already-exists d-flex justify-content-center">
                    Vous avez déjà un compte ?
                    <a routerLink="/" class="btn-forget-pwd">&nbsp; Se connecter</a>
                </div>
            </div>
    </form>
</div>
</app-auth>

